export const Baccarat = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
    >
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M24 12.62a3.2 3.2 0 0 0-1.977 5.716l-3.746 3.465-.005-.003-.002.002-2.756-1.685a3.2 3.2 0 1 0-3.602 1.578l1.504 7.935a1 1 0 0 0-.766.972v3.78a1 1 0 0 0 1 1h20.7a1 1 0 0 0 1-1V30.6a1 1 0 0 0-.767-.973l1.503-7.934a3.201 3.201 0 0 0-.786-6.303 3.2 3.2 0 0 0-2.819 4.717L29.723 21.8l-.006-.005-.007.004-3.744-3.455A3.2 3.2 0 0 0 24 12.62Zm-1.2 3.2a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0Zm1.192 3.2a3.307 3.307 0 0 1-.002 0h.002Zm10.014 2.497-3.883 2.385a1 1 0 0 1-1.202-.118L24 19.232l-4.921 4.552a1 1 0 0 1-1.202.118l-3.883-2.385a3.306 3.306 0 0 1-.082.035l1.526 8.048h17.124l1.526-8.048a3.306 3.306 0 0 1-.082-.035ZM14.65 33.38V31.6h18.7v1.78h-18.7ZM12.7 17.39a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Zm21.4 1.2a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0Z"
            clipRule="evenodd"
        />
    </svg>
);
